import { useState } from "react"

const primaryButton =
  "rounded-lg bg-dantzOrange px-6 py-2.5 font-medium text-white transition hover:brightness-110 active:scale-[0.98] disabled:opacity-60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dantzBlue"
const secondaryButton =
  "rounded-lg px-4 py-2.5 text-sm text-secondary4 transition hover:text-dantzBlue"

interface Props {
  codes: string[]
  doneLabel: string
  onDone: () => void
  // Said after the codes when other devices were signed out
  note?: string
}

// The backup codes are shown once, so this is the moment to keep them
export default function BackupCodes({ codes, doneLabel, onDone, note }: Props) {
  const [notice, setNotice] = useState("")

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(codes.join("\n"))
      setNotice("Backup codes copied.")
    } catch {
      setNotice("Copying did not work. Please write the codes down instead.")
    }
  }

  const download = () => {
    const file = new Blob([codes.join("\n") + "\n"], { type: "text/plain" })
    const link = document.createElement("a")
    link.href = URL.createObjectURL(file)
    link.download = "xpress-ip-backup-codes.txt"
    link.click()
    URL.revokeObjectURL(link.href)
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-green-700">Two-factor authentication is on.</p>
      <div className="rounded-lg bg-amber-50 px-3 py-2 text-sm text-amber-800">
        Save these backup codes now. Each one works once if you lose your
        phone, and they are not shown again.
        {note ? ` ${note}` : ""}
      </div>

      <ul className="grid grid-cols-2 gap-2 rounded-lg border border-gray-200 bg-gray-50 p-4 font-mono text-sm text-gray-800">
        {codes.map((code) => (
          <li key={code} className="select-all">
            {code}
          </li>
        ))}
      </ul>

      <div className="flex flex-wrap items-center gap-2">
        <button type="button" onClick={copy} className={primaryButton}>
          Copy
        </button>
        <button type="button" onClick={download} className={secondaryButton}>
          Download
        </button>
        <button type="button" onClick={onDone} className={secondaryButton}>
          {doneLabel}
        </button>
      </div>

      {notice && (
        <div className="rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700">
          {notice}
        </div>
      )}
    </div>
  )
}
